/**
 * `PlanService` 표를 런타임 문자열로 안전하게 여는 두 함수.
 */

import type { PlanId, PlanConfig, PlanSection } from 'src/types/plan/plan-domain';

import { PlanService } from 'src/constants/plan-service';

/** 문자열이 `PlanService` 의 행 키인가 — 런타임 문자열(planId)로 표를 열기 전에 좁힌다 */
export function isPlanId(id: string | null | undefined): id is PlanId {
  return typeof id === 'string' && Object.prototype.hasOwnProperty.call(PlanService, id);
}

/**
 * 동적 섹션 키로 연 값을 「키로 여는 섹션」으로 좁힌다 — 플랜 단위 문자열(`fixedCountry`)·빈 값은 `undefined`.
 * `config[accessKey]?.[accessField]` 꼴로 열던 자리가 전부 이것을 거친다(동작 동일 — 문자열을 다시 색인하면 어차피 undefined 였다).
 */
export function planSectionOf(
  config: PlanConfig | null | undefined,
  sectionKey: string | null | undefined,
): PlanSection | undefined {
  if (!config || !sectionKey) return undefined;
  const section = config[sectionKey];
  return section && typeof section === 'object' ? section : undefined;
}
